export default __webpack_public_path__ + "static/media/089.4d5e8cee.jpg";